import { Component, EventEmitter, Input, Output, ChangeDetectorRef } from '@angular/core';
import { CDN_IMAGES } from 'src/constants/param-constants';

@Component({
  selector: 'upsell-modal',
  templateUrl: './upsell-modal.component.html',
  styleUrls: ['./upsell-modal.component.scss']
})
export class UpsellModalComponent {
  constructor(private cdr: ChangeDetectorRef) {}

  @Input() set upsellModalInputs(value: {
    title: string;
    message: string;
    buttonText: string;
    html: string;
  }) {
    this._upsellModalInputs = value;
    this.cdr.detectChanges();
  }
  get upsellModalInputs(): {
    title: string;
    message: string;
    buttonText: string;
    html: string;
  } {
    return this._upsellModalInputs;
  }
  private _upsellModalInputs: {
    title: string;
    message: string;
    buttonText: string;
    html: string;
  } = { title: '', message: '', buttonText: '', html: '' };

  @Input() set show(value: boolean) {
    this._show = value;
    this.cdr.detectChanges();
  }
  get show(): boolean {
    return this._show;
  }
  private _show: boolean = false;

  @Output() close = new EventEmitter<void>();
  @Output() cta = new EventEmitter<void>();

  LOGO = CDN_IMAGES.LOGO;
  SCRUBS_IMAGE = CDN_IMAGES.SCRUBS;

  onClose() {
    this.close.emit();
  }

  onCTA() {
    this.cta.emit();
  }

  onBackdropClick(event: Event) {
    // Only close if clicking the backdrop (not the modal content)
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }
} 